"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.RepeatableList = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormattedComposite = _interopRequireDefault(require("../../Elements/FormattedComposite/FormattedComposite"));
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
const RepeatableList = ({
  initialList,
  onRemove,
  labelFormat,
  variant = 'button'
}) => {
  const [list, setList] = _react.default.useState(initialList);
  function handleRemove(index) {
    if (onRemove) {
      onRemove(list[index]);
    }
    const newList = list.filter((item, i) => i !== index);
    setList(newList);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "repeatable-list",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      children: list.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "d-flex justify-content-between",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "text-block",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedComposite.default, {
              config: {
                format: labelFormat,
                type: 'composite'
              },
              data: item
            })
          }), variant === 'icon' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            type: "delete",
            onClick: x => handleRemove(index)
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "btn btn-xs btn-danger pull-right",
            onClick: x => handleRemove(index),
            type: "button",
            children: "x"
          })]
        })
      }))
    })
  });
};
exports.RepeatableList = RepeatableList;